import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g(_vm._b({class:_vm.concatClasses,attrs:{"absolute":_vm.absolute,"name":_vm.qaIdentificationName,"color":_vm.color,"dark":_vm.dark,"disabled":_vm.isDisabled || _vm.loadPage,"icon":_vm.hasIcon,"href":_vm.href,"to":_vm.to}},"v-btn",_vm._d({},[_vm.type,true,_vm.contextButton,true,_vm.size,true])),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }